import React from 'react';
import {withRouter} from 'react-router-dom';

const GuestQuestionnaireSelector = ({visit, questionnaires = [], history}) => {
    if (visit.filledQuestionnaire) {
        return <span>Realizado</span>;
    }

    const onChange = (event) => {
        const url = event.target.value;
        if (url) {
            history.push(url);
        }
    };

    return (
        <select className="form-control"
                defaultValue=""
                onChange={onChange}
                aria-label="Seleccionar cuestionario">
            <option value="">Seleccionar cuestionario</option>
            {questionnaires.map(questionnaire => (
                <option
                    key={questionnaire.id}
                    value={questionnaire.isGcare
                        ? '/ee/questionnaires/gcare/' + visit.id
                        : '/ee/questionnaires/' + questionnaire.id + '/visit/' + visit.id}>
                    {questionnaire.name}
                </option>
            ))}
        </select>
    );
};

export default withRouter(GuestQuestionnaireSelector);
